import { useRouter } from 'next/router';
import * as React from 'react';

export const usePathname = () => {
  const router = useRouter();

  return React.useMemo(() => {
    return new URL(router.asPath, 'https://workos.com').pathname;
  }, [router.asPath]);
};
